<template>
  <div>
    <div style="color:white;font-size:45px;font-weight:500;">Detalle</div>
    <v-layout column style="margin:12px;border-radius:16px;" elevation-2>
      <v-flex>
        <v-card style="border-radius: 16px 16px 0px 0px;">
          <v-card-text>
            <v-layout justify-center>
              <v-flex xs12 xl10>
                <v-layout column>
                  <v-flex>
                    <v-container class="py-1">
                      <v-layout>
                        <v-flex xs12>
                          <v-text-field
                            v-model="textFilter"
                            clearable
                            label="Distribuidora"
                            hint="Introduzca el nombre de la distribuidora que busca"
                          ></v-text-field>
                        </v-flex>
                        <v-flex>
                          <v-btn
                            depressed rounded dark
                            class="strategio-card-button"
                            style="background-color:#00C3D7"
                            @click="clearFilters"
                          >
                            Limpiar&nbsp;<span class="hidden-xs-only">filtros</span>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-flex>
                  <v-flex class="hidden-sm-and-up">
                    <v-expansion-panel>
                      <v-expansion-panel-content>
                        <div slot="header" class="body-2">
                          Filtros
                        </div>
                          <v-divider></v-divider>
                        <!-- Componente -->
                        <v-container grid-list-lg>
                          <v-layout wrap>
                            <v-flex
                              xs12 sm4 md4 lg3
                              :key="card.cardType"
                              v-for="(card, i) in enabledCards"
                            >
                              <distributors-details-color-filter
                                :item="colorsFiltersMap[i]"
                                :card="card"
                              ></distributors-details-color-filter>
                            </v-flex>
                          </v-layout>

                        </v-container>

                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-flex>
                  <v-flex class="hidden-xs-only">
                    <v-container grid-list-lg class="py-1">
                      <v-layout wrap>
                        <v-flex
                          xs12 sm4 md4 lg3
                          :key="card.cardType"
                          v-for="(card, i) in enabledCards"
                        >
                          <distributors-details-color-filter
                            :item="colorsFiltersMap[i]"
                            :card="card"
                          ></distributors-details-color-filter>
                        </v-flex>
                      </v-layout>

                    </v-container>
                  </v-flex>
                </v-layout>

              </v-flex>
            </v-layout>

          </v-card-text>
        </v-card>
      </v-flex>
      <v-divider></v-divider>
      <v-flex
        :id="'distributorstate-cards'"
      >
        <v-card style="border-radius: 0px 0px 16px 16px;">
          <v-layout row wrap justify-center>
            <!-- <template v-if="true"> -->
            <template v-if="!isLoadingDistributors">
              <!-- :id="'distributorstate-cards'" -->
              <v-flex xs12 sm6 md6 lg6 xl6
                pa-3 px-4
                style="z-index:1;max-height:600px"
              >
                <v-layout style="border:1px red none;height:100%;overflow-y:auto;border-radius:16px;">
                  <distributors-details-list
                    :text-filter="textFilter"
                    :colors-filters="colorsFiltersMap"
                    :show-logs-details="showLogsDetails"
                    :detailed-distributor="detailedDistributor"
                  ></distributors-details-list>

                </v-layout>
              </v-flex>
              <v-flex
                xs12 sm6 md6 lg6 xl6
                hidden-xs-only
                style="border-left: 1px lightgray none; max-height: 600px;"
              >
                <distributor-details-log-report
                  :id="'distributorlog'"
                  :detailedDistributor="detailedDistributor"
                ></distributor-details-log-report>
              </v-flex>
            </template>
            <template v-else>
              <v-flex
                xs12 sm12 md8
                px-3
              >
                  <!-- color="primary" -->
                <v-progress-linear
                  class="strategio-progress-linear-component"
                  size="50"
                  indeterminate
                  v-if="isLoadingDistributors"
                ></v-progress-linear>

              </v-flex>
            </template>
          </v-layout>

        </v-card>
      </v-flex>

    </v-layout>
    <show-distributor-details-dialog
      :detailedDistributor="detailedDistributor"
      :showLogsDetails="showLogsDetails"
    ></show-distributor-details-dialog>
  </div>
</template>

<script>
import {map, filter} from 'lodash'

import cardsStorage from './../../storage/cardsStorage'

import DistributorsDetailsColorFilter from './distributors-details-color-filter'
import DistributorsDetailsList from './distributors-details-list'
import DistributorDetailsLogReport from './../../components/logs/distributor-details-log-report'
import ShowDistributorDetailsDialog from './../../components/dialogs/show-distributor-details-dialog'

export default {
  data () {
    return {
      textFilter: '',
      colorsFilters: [],
      cards: [],
      detailedDistributor: {}
    }
  },
  mounted () {
    this.cards = cardsStorage.getCardsPointer().cards
  },
  computed: {
    enabledCards () {
      return filter(this.cards, 'enabled')
    },
    colorsFiltersMap () {
      this.colorsFilters.splice(0)
      this.colorsFilters.push(...map(this.enabledCards, () => ({color: ''})))
      return this.colorsFilters
    }
  },
  methods: {
    showLogsDetails (item) {
      this.detailedDistributor = (this.detailedDistributor !== item) ? item : {}
    },
    clearFilters () {
      this.textFilter = ''
      this.colorsFilters.forEach((item) => {
        item.color = ''
      })
    }
  },
  components: {
    DistributorsDetailsColorFilter,
    DistributorsDetailsList,
    DistributorDetailsLogReport,
    ShowDistributorDetailsDialog
  },
  props: {
    isLoadingDistributors: {
      type: Boolean,
      default () {
        return true
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/supervisor/distributors-details.vue